<script lang="ts">
	import ProfileInputFrame from "./ProfileInputFrame.svelte";
	import { t } from "@hitit/hub/src/stores";

	export let messageTrnaslation = "";
	export let error = false;

</script>

<div class:displayNone={messageTrnaslation === ''}>
	<ProfileInputFrame inlineMode>
		<span class:error> {$t(messageTrnaslation)} </span>
	</ProfileInputFrame>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.displayNone {
		display: none;
	}

	span {
		font-size: 0.85rem;
		color: #6d6f76;

		&.error {
			color: #f66d6c;
		}
	}

	@include DesktopSize {
		span {
			font-size: 1rem;
			padding-left: 10px;
		}
	}

</style>
